import { cn } from '@/platform/lib/utils';
import { TabPanels as HeadlessTabPanels } from '@headlessui/react';

const TabPanels = ({ className, children, ...props }) => (
    <HeadlessTabPanels className={cn('mt-6', className)} {...props}>
        {children}
    </HeadlessTabPanels>
);

export default TabPanels;
